<template>
  <div>
    <!--<div class="hang_col" v-show="showFloat">
      <div @click="$router.push('/')">
        <div class="icon_box">
          <img src="@/assets/img/hang/优惠券.png" width="20px" height="20px" />
        </div>
        <span>优惠券</span>
      </div>
      <div @click="dialogInfoVisible = true">
        <div class="icon_box">
          <img src="@/assets/img/hang/意见反馈.png" width="20px" height="20px"/>
        </div>
        <span>意见反馈</span>
      </div>
    </div>-->
    <div class="hang_col hang_col2">
      <div @mouseover="showErweima" @mouseout="hiddenErweima" class="QR_button">
        <div class="icon_box">
          <img src="@/assets/img/hang/二维码2.png" v-if="seeErweima" width="20px" height="20px"/>
          <img src="@/assets/img/hang/二维码.png" v-else width="20px" height="20px"/>
        </div>
<!--        <span>二维码</span>-->
      </div>
      <div @click="backTop" v-show="showBack">
        <div class="icon_box">
          <img src="@/assets/img/hang/回到顶部.png" width="20px" height="20px"/>
        </div>
<!--        <span>回到顶部</span>-->
      </div>
    </div>
    <!--微信二维码-->
    <div class="weixin" v-show="seeErweima">
      <div>手机扫码 下载APP</div>
      <img src="@/assets/img/home/weixin.png" alt="微信二维码" width="128px" height="128px"/>
    </div>
    <el-dialog title="反馈信息" :visible.sync="dialogInfoVisible" width="700px" :lock-scroll="false" class="dialog">
      <OpinionsDemo @turnOffDialog="dialogInfoVisible = false"/>
    </el-dialog>
  </div>
</template>
<script>
import OpinionsDemo from "@/components/OpinionsDemo/OpinionsDemo";
export default {
  name: "Hang",
  components: {OpinionsDemo},
  data() {
    return {
      // 控制二维码展示的数据
      seeErweima: false,
      // 控制二维码展示的数据
      seeKefu: false,
      // 控制回到顶部按钮
      showBack: false,
      //判断反馈弹窗是否打开
      dialogInfoVisible: false,
      // 反馈弹窗的数据
      form: {idea: "", connect: "",},
      // 弹窗表单验证规则
      rules: {
        idea: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        connect: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
        ],
      },
      // 屏幕的宽度   控制客服悬浮窗的展示
      fullWidth: document.documentElement.clientWidth,
      showFloat: true,
    };
  },
  methods: {
    // 控制二维码展示的方法
    showErweima() {
      this.seeErweima = true;
    },
    hiddenErweima() {
      this.seeErweima = false;
    },
    // 控制客服信息展示的方法
    showKefu() {
      this.seeKefu = true;
    },
    hiddenKefu() {
      this.seeKefu = false;
    },
    // 控制回到顶部 显示/隐藏
    handleScroll() {
      //获取滚动时的高度
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 100 && !this.showBack) {
        //滚动大于100的时候要做的操作
        this.showBack = true;
      } else if (scrollTop <= 100 && this.showBack) {
        this.showBack = false;
        // console.log(this.showBack);
      }
    },
    // 回到顶部
    backTop() {
      let distance = document.documentElement.scrollTop || document.body.scrollTop; //获得当前高度
      let step = distance / 30; //每步的距离
      (function jump() {
        if (distance > 0) {
          distance -= step;
          window.scrollTo(0, distance);
          setTimeout(jump, 0);
        }
      })();
    },
  },
  mounted() {
    // 原生滚动
    const that = this;
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth;
        that.fullWidth = window.fullWidth;
      })()
    }
    // 监听 显示/隐藏 回到顶部
    window.addEventListener("scroll", this.handleScroll);
  },
  watch: {
    // 宽度小于1360时隐藏(现在已关闭该功能)
    fullWidth(val) {
      if (val < 1360) {
        this.showFloat = true;
      } else {
        this.showFloat = true;
      }
    }
  },
  destroyed() {
    // 销毁这个监听回到顶部  要不然会在其他的页面中 执行 报错
    document.removeEventListener("scroll", this.handleScroll);
  }
}
</script>

<style lang="scss" scoped>
// 悬挂客服样式
.hang_col {
  z-index: 12;
  width: 78px;
  // height: 380px;
  position: fixed;
  bottom: 400px;
  right: 10px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(216, 220, 224, 0.27);
}
.hang_col2 {
  z-index: 12;
  bottom: 197px !important;
  height: 160px;
  background-color: transparent;
  box-shadow: none !important;
  > div {
    background-color: #fff;
  }
}
.hang_col div {
  cursor: pointer;
  padding: 12px 10px;
  box-sizing: border-box;
}
.hang_col div span {
  margin-top: 5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #7d8191;
}

// 微信二维码
.weixin {
  z-index: 12;
  padding: 20px;
  position: fixed;
  bottom: 70px;
  right: 102px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(139, 139, 139, 0.26);
  border-radius: 4px;
  > div:nth-child(1) {
    width: 100%;
    text-align: center;
    font-size: 16px;
  ;
    font-weight: 100;
    color: #fe273b;
  }
}
.weixin::after {
  content: "";
  display: block;
  border-width: 8px;
  position: absolute;
  bottom: 135px;
  right: -16px;
  border-style: solid dashed dashed;
  border-color: transparent transparent transparent #fff;
  font-size: 0;
  line-height: 0;
}
.weixin img {
  margin: 12px 13px 15px 15px;
}
// 客服信息
.kefu {
  padding: 23px 32px 24px 20px;
  position: fixed;
  bottom: 260px;
  right: 102px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(139, 139, 139, 0.26);
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFang SC;
  color: #666666;
}
.kefu::after {
  content: "";
  display: block;
  border-width: 8px;
  position: absolute;
  bottom: 64px;
  right: -16px;
  border-style: solid dashed dashed;
  border-color: transparent transparent transparent #fff;
  font-size: 0;
  line-height: 0;
}
.kefu div:nth-child(1) {
  font-weight: 500;
}
.kefu div:nth-child(2) {
  font-weight: 400;
  margin-top: 14px;
}
// 弹出框中 第二个输入框
.input2 {
  margin-top: 40px;
}
.QR_button:hover {
  > span {
    color: #fff;
  }
  background-color: #fe273b;
}
</style>
<style scoped>
/* 设置dialog弹出框的样式 */
.dialog >>> .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 10px 10px 0px 0px;
  vertical-align: middle;
}
/* 弹出框标题字体 */
.dialog >>> .el-dialog__title {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #222222;
}
/* 叉叉设置 */
.dialog >>> .el-dialog__headerbtn {
  top: 20px;
  font-size: 24px;
}
.dialog >>> .el-dialog__body {
  padding: 20px 75px 57px 57px;
}
.dialog >>> .el-dialog__footer {
  text-align: left;
}
/* 输入框前缀字体 */
.dialog >>> .el-form-item__label {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #454545;
}
::v-deep .el-textarea__inner {
  resize: none;
}
/* 弹出框中Button的样式 */
.abutton {
  width: 194px;
  height: 50px;
  margin-left: 121px;
}
.el-button--primary {
  background-color: #2b79fe;
  color: #fff;
}
</style>